import React from 'react';
import "./components/Game/Game.scss"
import Game from './components/Game/Game';

function App() {
  return (
    <Game />
  );
}

export default App;
